import { useContext } from 'react';

import { RealtimeContext, type RealtimeContextType } from './RealtimeContext';

export const useRealtime = (): RealtimeContextType => {
  const context = useContext(RealtimeContext);

  if (!context) {
    throw new Error('useRealtime must be used inside RealtimeProvider');
  }

  return context;
};
